export const StarIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 1L7.545 4.13L11 4.635L8.5 7.07L9.09 10.51L6 8.885L2.91 10.51L3.5 7.07L1 4.635L4.455 4.13L6 1Z"
      fill="currentColor"
    />
  </svg>
);

export const DoneIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.8 8.4L2.4 6L1.6 6.8L4.8 10L11.2 3.6L10.4 2.8L4.8 8.4Z" fill="currentColor" />
  </svg>
);

export const TagIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 2.5H6L5.5 2L5 1.5H2C1.45 1.5 1 1.95 1 2.5V10.5C1 11.05 1.45 11.5 2 11.5H10C10.55 11.5 11 11.05 11 10.5V3.5C11 2.95 10.55 2.5 10 2.5ZM10 10.5H2V2.5H4.585L5.5 3.415H10V10.5Z"
      fill="currentColor"
    />
    <path d="M3 4H9V5H3V4ZM3 6H7V7H3V6Z" fill="currentColor" />
  </svg>
);

export const InProgressIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6.5 6.5H5.5V3H6.5V6.5ZM8 6.5H6.5V5.5H8V6.5Z"
      fill="currentColor"
    />
  </svg>
);

export const HourglassIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 1H9V3.5L7 6L9 8.5V11H3V8.5L5 6L3 3.5V1ZM4 2V3.25L6 5.75L8 3.25V2H4ZM6 6.25L4 8.75V10H8V8.75L6 6.25Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM5 8.5L2.5 6L3.205 5.295L5 7.085L8.795 3.29L9.5 4L5 8.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CancelIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM8.5 7.795L7.795 8.5L6 6.705L4.205 8.5L3.5 7.795L5.295 6L3.5 4.205L4.205 3.5L6 5.295L7.795 3.5L8.5 4.205L6.705 6L8.5 7.795Z"
      fill="currentColor"
    />
  </svg>
);

export const FeedbackIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 1H1.5C1.225 1 1 1.225 1 1.5V8.5C1 8.775 1.225 9 1.5 9H4L6 11L8 9H10.5C10.775 9 11 8.775 11 8.5V1.5C11 1.225 10.775 1 10.5 1ZM6.5 7.5H5.5V6.5H6.5V7.5ZM6.5 5.5H5.5V3H6.5V5.5Z"
      fill="currentColor"
    />
  </svg>
);
